"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectElementAccess = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
function selectElementAccess(config, feature, element) {
    if (!config) {
        return true;
    }
    const featureConfig = config[feature];
    const access = featureConfig === null || featureConfig === void 0 ? void 0 : featureConfig[element];
    return access === undefined || access === bridge_schema_1.UIAccessModifier.Regular;
}
exports.selectElementAccess = selectElementAccess;
